import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {customStorage} from './config';
import {ACCOUNT_STORAGE_KEY, DEFAULT_ACCOUNT_DATA} from './constants';
import {AccountDataStore} from './types';

export const useAccountDataStore = create<AccountDataStore>()(
	persist(
		(set, get) => ({
			accountData: DEFAULT_ACCOUNT_DATA,
			setAccountData: partial => {
				set({
					accountData: {
						...get().accountData,
						...partial,
					},
				});
			},
			resetAccountData: () => set({accountData: DEFAULT_ACCOUNT_DATA}),
		}),
		{
			name: ACCOUNT_STORAGE_KEY,
			storage: customStorage,
		},
	),
);
